import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateWithFallback',
  pure: false
})
export class TranslateWithFallbackPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: string, ...args: any[]): any {
    if (!value) return value;

    let translation = this.translateService.instant(value);
    if (translation === value) {
      return `?${value}?`;
    }
    return translation;
  }

}
